import React from "react";
import Image from '../../components/image';
import { CTAButtonV2 } from '../../components/ctabutton';
import { getLanguageField } from '../../utils/language';
import GalleryModalV2 from "../lodging/components/galleryModal/galleryModalv2";
import type { SplitImageProps, SplitImageState } from "./types";
import * as fullfillmentStyles from './fullfillment.module.scss'
import SliderComponent from 'src/@components/slider/slider.component';

import { slugify } from "src/utils/slugify";

//@ts-ignore
import { ModuleHeadV2 } from "src/components/moduleHead/moduleHead.v2";

export default class SplitImage extends React.Component<SplitImageProps, SplitImageState> {

  state: SplitImageState = {
    galleryModal: false,
    selectedImage: 0
  }

  get textContainerPaddings() {
    const { width, text_position, fulfill_position } = this.props.item;
    const padding = text_position === "right" ? "px-6 sm:px-0 sm:pr-8" : "px-6 sm:px-0 sm:pl-8"
    const margin = text_position === "right" ? "md:mr-auto" : "md:ml-auto"
    const fullfillpadding = text_position === "right" ? "md:pr-6 xl:pr-0" : "md:pl-6 xl:pl-0"

    if (width === "boxed" && fulfill_position) return padding;
    if (width === "boxed" && !fulfill_position) return "";
    if (fulfill_position) return `px-6 xl:px-0 ${fullfillpadding} ${margin} `;
    return ""
  }

  get textWidth(){
    const { text_weight_versus_image } = this.props.item;
    if (text_weight_versus_image === "50/50") return fullfillmentStyles.halfwidth;
    return "lg:w-2/3";
  }

  get isFullWidth() {
    return this.props.item.width === 'full_screen';
  }

  get wrapperDirection(){
    const { image_placement } = this.props.item;
    return image_placement === "bottom" ? "flex-col-reverse" : "flex-col";
  }


  get imageWidth(){
    const { text_weight_versus_image } = this.props.item;
    if (text_weight_versus_image === "50/50") return fullfillmentStyles.halfwidth;
    if (text_weight_versus_image === "66/33" && this.props.item.fulfill_position) return fullfillmentStyles.image_33;
    return "lg:w-1/3";
  }

  get id(){
    const { name, id = "" } = this.props.item;
    return `${slugify(name)}-${id}`;
  }

  get verticalAlignment(){
    const { vertical_alignment } = this.props.item;
    return vertical_alignment === "top" ? "items-start" : vertical_alignment === "bottom" ? "items-end" : "items-center";
  }

  get hasPreview() {
    return this.props.item.preview_image_on_click;
  }

  get boxedText(){
    const { boxed_content } = this.props.item;
    return boxed_content === "text";
  }

  get innerPadding(){
    if (this.boxedText) return "p-6 sm:p-9";
    return "";
  }

  get wrapperPadding(){
    if (!this.isFullWidth) return "py-8";
    return "";
  }

  get boxedBackgroundColor(){
    if (this.boxedText) return this.props.item.boxed_background_color?.value;
    return undefined;
  }

  get rounded(){
    const { rounded_corners, boxed_content } = this.props.item;
    return rounded_corners && boxed_content === "text" ? "rounded-2xl" : "";
  }

  renderImage(imageBehavior = "cover", roundedStyles = "", image = "", title = "", idx = 0) {
    return <Image imgStyle={{ objectFit: imageBehavior, objectPosition: "center center" }} backgroundColor={null} className={`${roundedStyles} w-full h-full object-cover`} src={image} alt={title + ''} key={`image-${idx}`}/>
  }

  render() {
    const moduleData = {
      title: getLanguageField(this.props.item.translations, this.props.selectedLanguage, 'title') as string | undefined,
      subtitle: getLanguageField(this.props.item.translations, this.props.selectedLanguage, 'subtitle') as string | undefined,
      description: getLanguageField(this.props.item.translations, this.props.selectedLanguage, 'body', true, true) as string | undefined,
      images: this.props.item.images,
      style: this.props.item?.style,
      alignment: this.props.item.text_position,
      template: true,
      anchor: getLanguageField(this.props?.item?.translations, this.props.selectedLanguage, 'anchor'),
      name: this.props?.item?.name,
      imageBehavior: this.props.item?.image_visualization_behavior || "cover",
      fullFillmentSpace: this.props.item?.fulfill_position,
      width: this.props.item.width,
      textWeightVersusImage: this.props.item.text_weight_versus_image || "50/50",
    };

    let colors = {
      background: this.props.item?.background_color?.value,
      title: this.props.item?.title_color?.value,
      subtitle: this.props.item?.subtitle_color?.value,
      description: this.props.item?.body_color?.value,
      text: this.props.item?.body_color?.value,
      arrow: this.props.item?.arrow_color?.value,
      arrowBubble: this.props.item?.arrow_bubble_color?.value,
      selectedBubbleIndicator: this.props.item?.selected_bubble_indicator_color?.value,
      unSelectedBubbleIndicator: this.props.item?.unselected_bubble_indicator_color?.value,
    };

    const alignment = moduleData.alignment

    const textMargin66Fullfilled = alignment === "right" ? fullfillmentStyles.text_margin_right : fullfillmentStyles.text_margin_left

    const textFullfilled = moduleData.textWeightVersusImage === "50/50" ? fullfillmentStyles.text_fullfilled : textMargin66Fullfilled
    let textContainerClass = moduleData.fullFillmentSpace ? textFullfilled : '';
    if (alignment === 'left' && moduleData.fullFillmentSpace) textContainerClass += ' ml-auto';

    const roundedStyles = moduleData.style === "rounded_corners" ? 'rounded-2xl' : "";

    const hasPrimaryButton = this.props.item.primary_cta;
    const hasSecondaryButton = this.props.item.secondary_cta;
    const hasSoftButton = this.props.item.soft_cta;
    const hasButtons = hasPrimaryButton || hasSecondaryButton || hasSoftButton;
    const hasImages = moduleData.images && moduleData.images.length
    const hasOneImage = hasImages && moduleData.images.length === 1;

    const renderImagesComponent = () => hasOneImage
      ? this.renderImage(moduleData.imageBehavior, roundedStyles, moduleData.images[0].image?.imageFile)
      : <SliderComponent
        id={this.id}
        slidesPerView={1}
        fallback={this.renderImage(moduleData.imageBehavior, roundedStyles, moduleData.images[0].image?.imageFile, moduleData.title)}
        className="flex w-full mx-auto"
        navigation
        loop
        navigation_bg={colors.arrowBubble}
        navigation_color={colors.arrow}
        pagination_selected_color={colors.selectedBubbleIndicator}
        pagination_unselected_color={colors.unSelectedBubbleIndicator}
        navigation_position={"absolute"}
      >
        {moduleData.images.map((image, idx: number) => {
          if (!image || !image.image || !image.image.imageFile) return null;
          const { imageFile } = image.image;
          if (this.hasPreview) return <button onClick={() => this.setState({ selectedImage: idx, galleryModal: true })} key={`image-${idx}`}>
            {this.renderImage(moduleData.imageBehavior, roundedStyles, imageFile, moduleData.title, idx)}
          </button>
          return this.renderImage(moduleData.imageBehavior, roundedStyles, imageFile, moduleData.title, idx)
        })}
      </SliderComponent>

    return (
      <div className={`mx-auto ${moduleData.fullFillmentSpace && moduleData.width === "full_screen" ? "max-w-full" : "max-w-7xl"} relative flex w-full ${this.wrapperPadding}`}>
        <div className={`flex ${this.wrapperDirection} lg:flex-row gap-6 sm:gap-8 md:gap-10 w-full ${this.verticalAlignment}`}>

          {/* IMAGE */}
          {
            hasImages ?
              <div className={`flex w-full ${this.imageWidth} relative ${alignment === 'right' ? '' : 'md:order-2'}`}>
                {renderImagesComponent()}
              </div>
              : null
          }
          {/* CONTENT */}
          <div className={`${textContainerClass} ${this.textContainerPaddings} flex items-center gap-6 w-full ${this.textWidth} md:order-1 `}>
            <div className={`md:w-full ${this.innerPadding} ${this.rounded}`} style={{backgroundColor: this.boxedBackgroundColor}}>
              {/* HEAD WITH TITLE, SUBTITLE AND DESCRIPTION */}
              <ModuleHeadV2
                title={moduleData.title}
                subtitle={moduleData.subtitle}
                description={moduleData.description}
                color_title={colors.title}
                color_subtitle={colors.subtitle}
                color_description={colors.description}
                is_hero={this.props.isHero}
              />
              {/* OPTIONAL CTA */}
              {hasButtons ?
                <div className="w-full inline-flex flex flex-col md:flex-row items-center gap-x-6 gap-y-4 md:gap-y-0 mb-4">
                  { this.props.item.primary_cta ? <CTAButtonV2
                    className="w-full md:w-auto"
                    language={this.props.selectedLanguage}
                    defaultLanguage={this.props.defaultLanguage}
                    ctabutton={this.props.item.primary_cta} /> : null }
                  { this.props.item.secondary_cta ? <CTAButtonV2
                    className="w-full md:w-auto"
                    language={this.props.selectedLanguage}
                    defaultLanguage={this.props.defaultLanguage}
                    ctabutton={this.props.item.secondary_cta} /> : null }
                  { this.props.item.soft_cta ? <CTAButtonV2
                    className="w-full md:w-auto"
                    language={this.props.selectedLanguage}
                    defaultLanguage={this.props.defaultLanguage}
                    ctabutton={this.props.item.soft_cta} /> : null }
                </div>
                : null }
            </div>
          </div>
          <GalleryModalV2
            closeFn={() => this.setState({ galleryModal: false })}
            open={this.state.galleryModal}
            images={
              moduleData.images
              .filter(image => image && image.image && image.image.imageFile)
              .map(image => image.image.imageFile)
            }
            language={this.props.selectedLanguage}
            size={"medium"}
            initialImageIndex={this.state.selectedImage}
          />
        </div>
      </div>
    )
  }
}